import { ClientDeployment } from "../app/shared/enums/client-deployment.enum";

export enum ENV_BUILD {
  EXCEEDERS = 0,
  STEMEXE,
  EBUILD,
  WELLNEXE
}

export const environment = {
  deploymentClient: ClientDeployment.DEFAULT, //Use this property for client customization
  build: ENV_BUILD.STEMEXE,
  production: true,
  isProduction: true,
  defaultDomainPostfix: ".stemexe.com",
  engProClientCode: "engagementpro-sslive",
  oppProClientCode: "OpportunityLive",
  oppProClientId: "XOP1956092300",
  oppProApiHost: "https://oppproliveapi.azurewebsites.net",
  oppProApi: "https://oppproliveapi.azurewebsites.net",
  idenediProviderUrl: "https://authapi.idenedi.com",
  idenediMlbackend: "https://idenedimlbackend.azurewebsites.net",
  authClientId: "idenedi_web_client",
  authClientSecret: "7x63u81880lnfyk",
  ipDataServiceUrl: "https://api.ipdata.co",
  ipDataApiKey: "f48d272d3d35f95b06a8ea3f1b49cdce960d8c37fe62903810febddb",
  apiHost: "https://api.idenedi.com",
  idenediStaticHost: "https://static.idenedi.com",
  searchHost: "https://searchapi.idenedi.com",
  idenediWebHost: "https://app.idenedi.com",
  technadoptApiHost: "https://saastech.azurewebsites.net",
  espApiHost: "https://esp.exceeders.com",
  webHost: "https://ss-stemexeuat.azurewebsites.net",
  idenediGroupId: "GUN2002011200",
  // idenediGroupIdForActivities: "GUN2002011200",
  supportUserId: "IPK1980101000",
  countDown: '',
  enableGroupsSelection: true,
  productContactFormWidgetUrl:
    "https://plannexe.exceeders.com/assets/v1.8.0.js",
  homePageTopicId: "8e4b4c4e-135d-4400-b523-ea99c5c4c9c6",
  homePageRequestId: "114",
  singleGroupApp: false,
  enableTopicHomePage: true,
  staging: false,
  msalAuth: {
    clientId: "3b744188-ce41-4514-9117-2e028edac581",
    authority: "https://login.microsoftonline.com/common", // 'bef7c58b-5197-4479-903d-9fb2e68261a7',
    validateAuthority: false,
    localId: "QHTm4Bg42._s18G-MztElxX0d~Y~JzY-tO",
    scopes: [
      "openid",
      "User.Read",
      "Calendars.ReadWrite",
      "Calendars.Read",
      "Calendars.ReadWrite.Shared",
      "Calendars.Read.Shared"
    ],
    endPoint: "https://graph.microsoft.com/v1.0"
  },
  enableThemes: true,
  exceederClientId: "XTD1963050800",
  engagementClientId: "XEP1968041200",
  SOCIAL_SHARING: {
    FB: {
      APP_ID: "345784772969902"
    },
    LINKEDIN: {
      APP_ID: "816bxkf51ta9m7",
      REDIRECT_URL:
        "https://app.idenedi.com/web/socialShare/linkedin_callback.html",
      SHARE_POST_URL:
        "https://app.idenedi.com/linkedin_share.php"
    },
    TWITTER: {
      APP_ID: "",
      LOADING_URL:
        "https://app.idenedi.com/web/socialShare/loading.html",
      SHARE_POST_URL:
        "https://app.idenedi.com/twitter_share.php"
    }
  },

  firebase: {
    apiKey: "AIzaSyD5t1aumB53jJ2SNbPTravuhc5iSLR7wsA",
    authDomain: "stemexe.firebaseapp.com",
    databaseURL: "https://stemexe.firebaseio.com",
    projectId: "stemexe",
    storageBucket: "stemexe.appspot.com",
    messagingSenderId: "269621766361",
    appId: "1:269621766361:web:ff84cb9ce21e814b6db6c8",
    measurementId: "G-56YZXYH7H4",
    dynamicLink: {
      domainUriPrefix: "https://stemexe.page.link",
      androidPackageName: "com.exceeders.stemexe",
      iosBundleId: "com.exceeders.stemeXe"
    }
  },
  recaptcha3SiteKey: '',
  enableAppCheck: false,
  version: "4.1.4",
  higherBaseURL: 'https://higher.exceeders.com',
  vacancyTempWork: false,
  customDomainFallbackUrl: 'https://ss-stemexeuat.azurewebsites.net',
  engagementPro: {
    baseURL: 'https://engage.exceeders.com/webapi',
    clientId: 'XEP1992010100',
  },

  plannexe: {
    baseURL: 'https://plannexeapi.azurewebsites.net',
    webLink: 'https://plannexe.exceeders.com',
    inviteURL: 'https://plannexe.exceeders.com/auth/user/invite/',
    simpleStartBaseURL: 'https://ss-production-gateway.azurewebsites.net/webapi/api/TeamApi/',
    simpleStrataUrl:"https://ss-production-gateway.azurewebsites.net/webapi",
    isSentry: false,
    sentry: 'https://ac59ab68437fb55b993d94b8f950d44b@o4505906761629696.ingest.sentry.io/4505907067551744',
    file: {
      api: 'https://exceedfileserver.azurewebsites.net',
      clientID: 'EngagementProV2Live',
      apiKey: '7UU9-8O9Z-F9HC-Y10Y'
    },
    idenedi: {
      api: 'https://api.idenedi.com',
      auth: 'https://idenedi.com',
      clientID: 'XEP1968041200',
      redirect: 'https://plannexe.exceeders.com/auth/login/idenedi',
      group: 'https://authapi.idenedi.com/LinkGroup.html',
    },
    moduleLink: "/pages/engagement",
    isStemexe: true,
    chatAiBaseUrl: 'https://chataiex.azurewebsites.net',
    consoleEnabled: false,
  },
  sellexe: {
    baseUrl: 'https://exceedersopportunityapifast.azurewebsites.net/apiv3',
    moduleLink: 'pages/sellexe/',
    webUrl: '',
    idenedi: {
      api: 'https://api.idenedi.com',
      auth: 'https://idenedi.com',
      clientID: 'XSE1971081200',
      redirect: 'https://opportunity.exceeders.com/auth/idenedicode/',
      group: 'https://authapi.idenedi.com/LinkGroup.html',
    }
  },
  simpleStrata:{
    mainURL: 'https://ss-production-gateway.azurewebsites.net/webapi/',
    isStemexe: true,
  },
  notificationService: {
    apiConnectURL: 'https://notificationservice-auth-testing.azurewebsites.net',
    apiURL: 'https://notificationservice-api-testing.azurewebsites.net',
    clientID: 'GtU6Uc01y676',
    clientSecret: 'yhSL29kCUNPeY4gfVxSBmsym',
    grantType: 'client_credentials'
  },
  enableGlobalSlides: false,
  allowPublicAcess: true,
  intajyClientId: 'XIN1973102300',
  intajyBaseUrl: 'https://stemexe.meetexe.com',
  intajyApiUrl: 'https://api.meetexe.com',
  intajyAppUrl:"https://api2.meetexe.com",
  aimeetexeApiUrl:'https://ai-api.meetexe.com',
  aimeetexeApiKey:'ST-ABNWmYopDy-vjVXRJxBA2dTrk-ZL3VJzNUSLcWss-cF6B7pkHgTS4g7C',
  virtualRoomIntajyApiUrl:"https://room-api.meetexe.com",
  virtualRoomClientId: 'XVR1957112300',
  connectexeDetailsUrl: 'https://www.perfexe.com/pages/connectexe-lb',
  forceProfileCompletion: true,
  defaultLocale: 'en',
  themeColors: {}
};
